module.exports = __webpack_public_path__ + "static/media/user.be582403.svg";